module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TankCraft 36")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _c('p', {
    staticClass: "title1"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("PANZER III")])]), _vm._v(" "), _c('p', {
    staticClass: "title2"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("GERMAN ARMY LIGHT TANK")])]), _vm._v(" "), _c('p', {
    staticClass: "title3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("NORTH AFRICA")])]), _vm._v(" "), _c('p', {
    staticClass: "title4"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TRIPOLI TO EL ALAMEIN, 1941-1942")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dennis Oliver")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5442b88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Title.vue
// module id = 60
// module chunks = 0